<div class="map-shell">
	<!-- Buscador (solo edición): forward geocoding con el mismo Nominatim del reverse -->
	<div class="map-search" *ngIf="editing">
		<div class="ms-box">
			<mat-icon>search</mat-icon>
			<input
				type="text"
				[value]="searchText"
				(input)="onSearchInput($any($event.target).value)"
				(keydown.escape)="closeResults()"
				[placeholder]="'centro.map.search' | translate"
				autocomplete="off"
			/>
			<span *ngIf="searching" class="ms-spin" aria-hidden="true"></span>
		</div>
		<div class="ms-panel" *ngIf="showResults && !searching">
			<!-- Coordenadas pegadas: navegación directa, sin red -->
			<button
				type="button"
				class="ms-opt ms-opt-coords"
				*ngIf="coordCandidate"
				(click)="goToCoordCandidate()"
			>
				<mat-icon>my_location</mat-icon>
				<span class="ms-opt-tx">
					{{ "centro.map.goToCoords" | translate }}
					<b>{{ coordCandidate.lat.toFixed(5) }}, {{ coordCandidate.lng.toFixed(5) }}</b>
				</span>
			</button>
			<button
				type="button"
				class="ms-opt"
				*ngFor="let r of results"
				(click)="selectResult(r)"
			>
				<mat-icon>place</mat-icon>
				<span class="ms-opt-tx">{{ r.display_name }}</span>
			</button>
			<div class="ms-empty" *ngIf="!results.length && !coordCandidate">
				{{ "centro.map.noResults" | translate }}
			</div>
		</div>
	</div>

	<!-- Mapa -->
	<div class="map-frame" [class.is-editing]="editing">
		<div id="map"></div>
	</div>

	<!-- Readout de coordenadas (informativo, no protagonista) + recentrar -->
	<div class="map-coords">
		<mat-icon>my_location</mat-icon>
		<span class="mc-val">{{ coordsLabel }}</span>
		<span class="mc-city" *ngIf="ciudadLabel">· {{ ciudadLabel }}</span>
	</div>
	<button
		type="button"
		class="map-recenter"
		(click)="recenter()"
		[matTooltip]="'centro.map.recenter' | translate"
	>
		<mat-icon>filter_center_focus</mat-icon>
	</button>

	<!-- Ubicación pendiente (alta sin coordenadas): aviso superpuesto -->
	<div class="map-required" *ngIf="editing && coordsInvalid">
		<mat-icon>warning</mat-icon>
		{{ "centro.map.required" | translate }}
	</div>
</div>
